// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-container{padding-bottom:20px}.label-container,.label-row{align-items:flex-end;display:flex;flex-direction:column;gap:10px;width:100%}.label{align-items:center;border-radius:5px;display:flex;height:25px;justify-content:center;max-width:100%;overflow:hidden;padding:10px;text-align:center;text-overflow:ellipsis;white-space:nowrap;width:auto}", ""]);
// Exports
module.exports = exports;
